const ETAnchorType=["Threaded Rod","Headed Bolt","Headed Stud","Hooked Bolt"]
const Edge = {Top:0, Bottom:1, Right:2, Left:3}

export default function AnchorACIDesignClass() { }

AnchorACIDesignClass.prototype.chapter9PhiFactors = [[.75, .75], [.65, .65], [.75, .7], [.75, .7]],

AnchorACIDesignClass.prototype.appendixCPhiFactors = [[.8, .8], [.75, .75], [.85, .85], [.85, .75]],

AnchorACIDesignClass.prototype.SeismicFactor = function (highSeismic) {
    return highSeismic ? .75 : 1
},

AnchorACIDesignClass.prototype.GetPhiFactor = function (index, condition, chapter9) {
    return chapter9 ? this.chapter9PhiFactors[index][condition] : this.appendixCPhiFactors[index][condition]
},

AnchorACIDesignClass.prototype.MaxEdgeDistance = function (oGeometry, oBolt) {
    var maxEdge = oGeometry.MaxEdgeToALimit(1.5 * oBolt.embedDepth);
    return maxEdge
},

AnchorACIDesignClass.prototype.NumberOfNearEdges = function (oGeometry, oBolt) {
    var h15 = 1.5 * oBolt.embedDepth;
    return oGeometry.EdgesLessThan(h15)
},

AnchorACIDesignClass.prototype.EffectiveEmbed = function (oGeometry, oBolt) {
    var embed = oBolt.embedDepth;
    return this.NumberOfNearEdges(oGeometry, oBolt) >= 3 && (embed = Math.max(this.MaxEdgeDistance(oGeometry, oBolt) / 1.5, Math.max(oGeometry.rowSpacing, oGeometry.colSpacing) / 3)), embed
},

AnchorACIDesignClass.prototype.EdgeEffectTensionFactor = function (oGeometry, oBolt) {
    var psi = 1;
    return oGeometry.MinEdge() <= 1.5 * this.EffectiveEmbed(oGeometry, oBolt) && (psi = .7 + .3 * (oGeometry.MinEdge() / (1.5 * this.EffectiveEmbed(oGeometry, oBolt)))), psi
},

AnchorACIDesignClass.prototype.Ca2_N = function (oGeometry, oBolt) {
    var ca2 = 1.5 * this.EffectiveEmbed(oGeometry, oBolt),
        minPerpEdge = 0,
        minGeometryEdge = oGeometry.MinEdge();
    return minGeometryEdge === Number(oGeometry.topEdge) && (minPerpEdge = oGeometry.MinPerpendicularEdge(Edge.Top)),
        minGeometryEdge === Number(oGeometry.bottomEdge) && (minPerpEdge = oGeometry.MinPerpendicularEdge(Edge.Bottom)),
        minGeometryEdge === Number(oGeometry.rightEdge) && (minPerpEdge = oGeometry.MinPerpendicularEdge(Edge.Right)),
        minGeometryEdge === Number(oGeometry.leftEdge) && (minPerpEdge = oGeometry.MinPerpendicularEdge(Edge.Left)),
        ca2 > minPerpEdge && (ca2 = minPerpEdge), ca2
},

AnchorACIDesignClass.prototype.Ca2_Vx = function (oGeometry) {
    var ca2_vx = oGeometry.MinPerpendicularEdge(Edge.Right);
    return ca2_vx
},

AnchorACIDesignClass.prototype.Ca2_Vy = function (oGeometry) {
    var ca2_vy = oGeometry.MinPerpendicularEdge(Edge.Top);
    return ca2_vy
},

AnchorACIDesignClass.prototype.InteractionCheck = function (Vua, phiVn, Nua, phiNn) {
    var InteractionValue = Math.pow(Math.abs(Nua) / Math.abs(phiNn), 5 / 3) + Math.pow(Math.abs(Vua) / Math.abs(phiVn), 5 / 3);
    return InteractionValue
},

AnchorACIDesignClass.prototype.Nsa = function (oBolt, oGeometry) {
    var nsa = oGeometry.NumberOfBolts() * oBolt.GetArea() * oBolt.tensileStrength;
    return nsa
},

AnchorACIDesignClass.prototype.Ncb = function (oGeometry, oBolt, fpc) {
    var ncb = this.Anc(oGeometry, oBolt) / this.Anco(oGeometry, oBolt) * this.EdgeEffectTensionFactor(oGeometry, oBolt) * this.Nb(oGeometry, oBolt, fpc);
    return ncb
},

AnchorACIDesignClass.prototype.Anco = function (oGeometry, oBolt) {
    var anco = 9 * Math.pow(this.EffectiveEmbed(oGeometry, oBolt), 2);
    return anco
},

AnchorACIDesignClass.prototype.Anc = function (oGeometry, oBolt) {
    var h15 = 1.5 * this.EffectiveEmbed(oGeometry, oBolt),
        edgeTop = Math.min(h15, oGeometry.topEdge),
        edgeBottom = Math.min(h15, oGeometry.bottomEdge),
        edgeRight = Math.min(h15, oGeometry.rightEdge),
        edgeLeft = Math.min(h15, oGeometry.leftEdge),
        Anc = (edgeTop + oGeometry.BoltGroupHeight() + edgeBottom) * (edgeLeft + oGeometry.BoltGroupWidth() + edgeRight);
    return Anc > oGeometry.NumberOfBolts() * this.Anco(oGeometry, oBolt) && (Anc = oGeometry.NumberOfBolts() * this.Anco(oGeometry, oBolt)), Anc
},

AnchorACIDesignClass.prototype.Nb = function (oGeometry, oBolt, fpc) {
    var Nb = 24 * Math.sqrt(1e3 * fpc) * Math.pow(this.EffectiveEmbed(oGeometry, oBolt), 1.5) / 1e3,
        areEmbedLimitsMet = !1;
    switch (this.EffectiveEmbed(oGeometry, oBolt) >= 11 && this.EffectiveEmbed(oGeometry, oBolt) <= 25 && (areEmbedLimitsMet = !0), oBolt.anchorType) {
        case ETAnchorType[0]:
            areEmbedLimitsMet === !0 && (Nb = 16 * Math.sqrt(1e3 * fpc) * Math.pow(this.EffectiveEmbed(oGeometry, oBolt), 5 / 3) / 1e3);
            break;
        case ETAnchorType[1]:
            areEmbedLimitsMet === !0 && (Nb = 16 * Math.sqrt(1e3 * fpc) * Math.pow(this.EffectiveEmbed(oGeometry, oBolt), 5 / 3) / 1e3);
            break;
        case ETAnchorType[2]:
            areEmbedLimitsMet === !0 && (Nb = 16 * Math.sqrt(1e3 * fpc) * Math.pow(this.EffectiveEmbed(oGeometry, oBolt), 5 / 3) / 1e3)
    }
    return Nb
},

AnchorACIDesignClass.prototype.considerSideFaceBlowout = function (oGeometry, oBolt, ca1) {
    if (oBolt.IsAnchorHooked()) return !1;
    var a = !1,
        isLessThanHef = !1;
    return ca1 < .4 * oBolt.embedDepth && (isLessThanHef = !0),
        1 === oGeometry.NumberOfBolts() && isLessThanHef === !0 && (a = !0),
        oGeometry.NumberOfBolts() > 1 && isLessThanHef === !0 && oGeometry.MinSpacing() < 6 * ca1 && (a = !0), a
},

AnchorACIDesignClass.prototype.Nsbg = function (oGeometry, oBolt, fpc) {
    var ca1 = oGeometry.MinEdge(),
        ca2 = this.Ca2_N(oGeometry, oBolt),
        nsb = 160 * ca1 * Math.sqrt(oBolt.GetBearingArea()) * Math.sqrt(1e3 * fpc) / 1e3;
    if (this.considerSideFaceBlowout(oGeometry, oBolt, ca1) === !0) {
        if (1 === oGeometry.NumberOfBolts()) {
            var m = Math.min(3, ca2 / ca1);
            3 * ca1 > ca2 && (nsb = (1 + m) / 4 * nsb)
        }
        oGeometry.NumberOfBolts() > 1 && (nsb = (1 + oGeometry.MinSpacing() / (6 * ca1)) * nsb)
    } else nsb = 1e20;

    return nsb
},

AnchorACIDesignClass.prototype.Condition = function (oConcrete) {
    return oConcrete.barsCrossTensionFailure || oConcrete.barsPreventTensionBreakout ? 0 : 1
},

AnchorACIDesignClass.prototype.EffectiveHookLength = function (oBolt) {
    var hookLength = oBolt.hookLength;
    return hookLength > 4.5 * oBolt.GetDiameter() && (hookLength = 4.5 * oBolt.GetDiameter()),
        hookLength
},

AnchorACIDesignClass.prototype.Np = function (oGeometry, oBolt, fpc) {
    var np = 0;
    if (oBolt.IsAnchorHooked()) {
        var hookLength = this.EffectiveHookLength(oBolt);
        np = hookLength >= 3 * oBolt.GetDiameter() ? .9 * fpc * hookLength * oBolt.GetDiameter() : 0
    } else np = 8 * oBolt.GetBearingArea() * fpc;

    return np
},

AnchorACIDesignClass.prototype.Npn = function (oGeometry, oBolt, fpc) {
    var np = this.Np(oGeometry, oBolt, fpc),
        npn = np * oGeometry.NumberOfBolts();
    return npn
},

AnchorACIDesignClass.prototype.Vsa = function (oBolt, oGeometry) {
    var vsa = .6 * oGeometry.NumberOfBolts() * oBolt.GetArea() * oBolt.tensileStrength;
    return oBolt.IsHeadedStud() && (vsa = oGeometry.NumberOfBolts() * oBolt.GetArea() * oBolt.tensileStrength),
        oBolt.groutPads && (vsa = .8 * vsa), vsa
},

AnchorACIDesignClass.prototype.Vb = function (oBolt, ca1, fpc) {
    // 17.7.2.2.1 - sussane dawson bug report (lesser of 17.7.2.2.1a and 17.7.2.2.1b)
    let lambdaA = 1.0
    var le = Math.min(oBolt.embedDepth, 8 * oBolt.GetDiameter()),
        vb_a = 7 * lambdaA * Math.pow(le / oBolt.GetDiameter(), .2) * Math.sqrt(oBolt.GetDiameter()) * Math.sqrt(1e3 * fpc) * Math.pow(ca1, 1.5) / 1e3,
        vb_b = 9 * lambdaA * Math.sqrt(1e3 * fpc) * Math.pow(ca1, 1.5) / 1e3;
    return Math.min(vb_a, vb_b)
},

AnchorACIDesignClass.prototype.EffectiveShearEdgeDistance = function (oGeometry, ca1, ca2, thickness) {
    let edges = oGeometry.EdgesLessThan(1.5 * ca1)
    if (edges >= 3) {
        let effThickness = Math.min(1.5 * ca1, thickness)
        var ca1_eff = Math.max(ca2 / 1.5, Math.max(effThickness / 1.5, oGeometry.MaxSpacing() / 3));
        return ca1_eff > ca1 ? ca1 : ca1_eff
    }
    return ca1
},

AnchorACIDesignClass.prototype.EdgeShearFactor = function (ca1, ca2) { 
    var Psi_edV = 1; 
    return 1.5 * ca1 > ca2 && (Psi_edV = .7 + .3 * (ca2 / (1.5 * ca1))), Psi_edV 
},

AnchorACIDesignClass.prototype.CrackedConcShearFactor = function (noShearBreakout, supp4BarReinf, stirrups) { 
    var Psi_cV = 1; 
    return supp4BarReinf === !0 && (Psi_cV = 1.2), 
    supp4BarReinf === !0 && stirrups === !0 && (Psi_cV = 1.4), 
    noShearBreakout === !0 && (Psi_cV = 1e20), Psi_cV 
},

AnchorACIDesignClass.prototype.ConcreteThicknessFactor = function (ca1, ha) { 
    var Psi_hV = 0; 
    return Psi_hV = 1.5 * ca1 > ha ? Math.sqrt(1.5 * ca1 / ha) : 1 
},

AnchorACIDesignClass.prototype.Avco = function (ca1) { 
    var avco = 4.5 * Math.pow(ca1, 2); 
    return avco 
},

AnchorACIDesignClass.prototype.Avc_X = function (oGeometry, ca1, thickness) { 
    var topDimension = Math.min(1.5 * ca1, oGeometry.topEdge), 
    bottomDimension = Math.min(1.5 * ca1, oGeometry.bottomEdge), 
    effThickness = Math.min(1.5 * ca1, thickness), 
    avc = (topDimension + oGeometry.rowSpacing * (oGeometry.rows - 1) + bottomDimension) * effThickness; 
    return avc = Math.min(avc, oGeometry.NumberOfBolts() * this.Avco(ca1)) 
},

AnchorACIDesignClass.prototype.shearEdgeVx = function (oGeometry, oLoad) { 
    var shearEdge = 0; 
    return oLoad.vX > 0 && (shearEdge = oGeometry.rightEdge), 
    oLoad.vX < 0 && (shearEdge = oGeometry.leftEdge), 
    0 === oLoad.vX && (shearEdge = Math.min(oGeometry.rightEdge, oGeometry.leftEdge)), shearEdge 
},

AnchorACIDesignClass.prototype.Ca1_Vx = function (oBolt, oGeometry, oLoad, oConcrete) { 
    var ca2 = this.Ca2_Vx(oGeometry), 
    shearEdge = this.shearEdgeVx(oGeometry, oLoad), 
    ca1 = shearEdge; 
    return ca1 = this.EffectiveShearEdgeDistance(oGeometry, ca1, ca2, oConcrete.thickness), oBolt.anchorsWelded && (ca1 = shearEdge + oGeometry.colSpacing), ca1 
},

AnchorACIDesignClass.prototype.vcb_X = function (shearEdge, oBolt, oGeometry, oConcrete) { 
    let ca2 = this.Ca2_Vx(oGeometry)
    let ca1 = shearEdge
    ca1 = this.EffectiveShearEdgeDistance(oGeometry, ca1, ca2, oConcrete.thickness)
    let avc = this.Avc_X(oGeometry, ca1, oConcrete.thickness)
    let anco = this.Avco(ca1)
    let psi_ec = this.EdgeShearFactor(ca1, ca2)
    let psi_ed = this.CrackedConcShearFactor(oConcrete.shearXNoBreakout, oConcrete.shearXNumber4Bars, oConcrete.shearXStirrups)
    let psi_c = this.ConcreteThicknessFactor(ca1, oConcrete.thickness)
    let vb = this.Vb(oBolt, ca1, oConcrete.fc)
    let vcb = avc / anco * psi_ec * psi_ed * psi_c * vb
    return vcb
},

// case 1 - distance from front bolt, distribute shear accross columns
AnchorACIDesignClass.prototype.Vcb_X_case1 = function (oBolt, oGeometry, oLoad, oConcrete) { 
    let shearEdge = this.shearEdgeVx(oGeometry, oLoad)
    return this.vcb_X(shearEdge, oBolt, oGeometry, oConcrete) * oGeometry.columns
},

// case 2 - get distance from rear bolt to edge, do not distribute shear
AnchorACIDesignClass.prototype.Vcb_X_case2 = function (oBolt, oGeometry, oLoad, oConcrete) { 
    let shearEdge = this.shearEdgeVx(oGeometry, oLoad) + (oGeometry.columns - 1) * oGeometry.colSpacing
    return this.vcb_X(shearEdge, oBolt, oGeometry, oConcrete)
},

// case 3 - distance from front bolt, do not distribute shear
AnchorACIDesignClass.prototype.Vcb_X_case3 = function (oBolt, oGeometry, oLoad, oConcrete) { 
    let shearEdge = this.shearEdgeVx(oGeometry, oLoad)
    return this.vcb_X(shearEdge, oBolt, oGeometry, oConcrete)
},

// 17.7.2.2.1a (ACI 318-19) and 17.7.2.2.1b
AnchorACIDesignClass.prototype.Vcb_X = function (oBolt, oGeometry, oLoad, oConcrete) { 
    let ca2 = this.Ca2_Vx(oGeometry)
    let shearEdge = this.shearEdgeVx(oGeometry, oLoad)
    let ca1 = shearEdge
    ca1 = this.EffectiveShearEdgeDistance(oGeometry, ca1, ca2, oConcrete.thickness)
    
    const vcb_case1 = this.Vcb_X_case1(oBolt, oGeometry, oLoad, oConcrete)
    const vcb_case2 = this.Vcb_X_case2(oBolt, oGeometry, oLoad, oConcrete)
    const vcb_case3 = this.Vcb_X_case3(oBolt, oGeometry, oLoad, oConcrete)
    
    if(oBolt.anchorsWelded) {
        // only case 2 - rear bolt to edge, do not distribute shear
        return vcb_case2
    } else if(oGeometry.colSpacing > ca1) {
        // case 1 distance from front bolt, distribute shear
        // case 2 distance from rear bolt, do not distribute shear
        return Math.min(vcb_case1, vcb_case2)
    } else {
        // case 3 distance from front bolt, do not distribute shear
        return vcb_case3
    }
},

AnchorACIDesignClass.prototype.Avc_Y = function (oGeometry, ca1, thickness) { 
    var leftDimension = Math.min(1.5 * ca1, oGeometry.leftEdge), 
    rightDimension = Math.min(1.5 * ca1, oGeometry.rightEdge), 
    effThickness = Math.min(1.5 * ca1, thickness), 
    avc = (leftDimension + oGeometry.colSpacing * (oGeometry.columns - 1) + rightDimension) * effThickness; 
    return avc = Math.min(avc, oGeometry.NumberOfBolts() * this.Avco(ca1)) 
},

AnchorACIDesignClass.prototype.shearEdgeVy = function (oGeometry, oLoad) { 
    var shearEdge = 0; 
    return oLoad.vY > 0 && (shearEdge = oGeometry.topEdge), 
    oLoad.vY < 0 && (shearEdge = oGeometry.bottomEdge), 
    0 === oLoad.vY && (shearEdge = Math.min(oGeometry.topEdge, oGeometry.bottomEdge)), shearEdge 
},

AnchorACIDesignClass.prototype.Ca1_Vy = function (oBolt, oGeometry, oLoad, oConcrete) { 
    var ca2 = this.Ca2_Vy(oGeometry), 
    shearEdge = this.shearEdgeVy(oGeometry, oLoad), 
    ca1 = shearEdge; 
    return ca1 = this.EffectiveShearEdgeDistance(oGeometry, ca1, ca2, oConcrete.thickness), 
    oBolt.anchorsWelded && (ca1 = shearEdge + oGeometry.rowSpacing), ca1 
},

AnchorACIDesignClass.prototype.vcb_Y = function (shearEdge, oBolt, oGeometry, oConcrete) { 
    let ca2 = this.Ca2_Vy(oGeometry)
    let ca1 = shearEdge
    ca1 = this.EffectiveShearEdgeDistance(oGeometry, ca1, ca2, oConcrete.thickness)
    let avc = this.Avc_Y(oGeometry, ca1, oConcrete.thickness)
    let anco = this.Avco(ca1)
    let psi_ec = this.EdgeShearFactor(ca1, ca2)
    let psi_ed = this.CrackedConcShearFactor(oConcrete.shearYNoBreakout, oConcrete.shearYNumber4Bars, oConcrete.shearYStirrups)
    let psi_c = this.ConcreteThicknessFactor(ca1, oConcrete.thickness)
    let vb = this.Vb(oBolt, ca1, oConcrete.fc)
    let vcb = avc / anco * psi_ec * psi_ed * psi_c * vb
    return vcb
},

// case 1 - distance from front bolt, distribute shear accross columns
AnchorACIDesignClass.prototype.Vcb_Y_case1 = function (oBolt, oGeometry, oLoad, oConcrete) { 
    let shearEdge = this.shearEdgeVy(oGeometry, oLoad)
    return this.vcb_Y(shearEdge, oBolt, oGeometry, oConcrete) * oGeometry.rows
},

// case 2 - get distance from rear bolt to edge, do not distribute shear
AnchorACIDesignClass.prototype.Vcb_Y_case2 = function (oBolt, oGeometry, oLoad, oConcrete) { 
    let shearEdge = this.shearEdgeVy(oGeometry, oLoad) + (oGeometry.rows - 1) * oGeometry.rowSpacing
    return this.vcb_Y(shearEdge, oBolt, oGeometry, oConcrete)
},

// case 3 - distance from front bolt, do not distribute shear
AnchorACIDesignClass.prototype.Vcb_Y_case3 = function (oBolt, oGeometry, oLoad, oConcrete) { 
    let shearEdge = this.shearEdgeVy(oGeometry, oLoad)
    return this.vcb_Y(shearEdge, oBolt, oGeometry, oConcrete)
},

// 17.7.2.2.1a (ACI 318-19) and 17.7.2.2.1b
AnchorACIDesignClass.prototype.Vcb_Y = function (oBolt, oGeometry, oLoad, oConcrete) { 
    let ca2 = this.Ca2_Vy(oGeometry)
    let shearEdge = this.shearEdgeVy(oGeometry, oLoad)
    let ca1 = shearEdge
    ca1 = this.EffectiveShearEdgeDistance(oGeometry, ca1, ca2, oConcrete.thickness)
    
    const vcb_case1 = this.Vcb_Y_case1(oBolt, oGeometry, oLoad, oConcrete)
    const vcb_case2 = this.Vcb_Y_case2(oBolt, oGeometry, oLoad, oConcrete)
    const vcb_case3 = this.Vcb_Y_case3(oBolt, oGeometry, oLoad, oConcrete)
    
    if(oBolt.anchorsWelded) {
        // only case 2 - rear bolt to edge, do not distribute shear
        return vcb_case2
    } else if(oGeometry.rowSpacing > ca1) {
        // case 1 distance from front bolt, distribute shear
        // case 2 distance from rear bolt, do not distribute shear
        return Math.min(vcb_case1, vcb_case2)
    } else {
        // case 3 distance from front bolt, do not distribute shear
        return vcb_case3
    }
},

AnchorACIDesignClass.prototype.Kcp = function (oBolt) { 
    var kcp = 1; 
    return oBolt.embedDepth >= 2.5 && (kcp = 2), kcp 
},

AnchorACIDesignClass.prototype.Vcp = function (oGeometry, oBolt, fpc) { 
    var kcp = this.Kcp(oBolt), 
    vcp = kcp * this.Ncb(oGeometry, oBolt, fpc); 
    return vcp 
}
